<template>
    <ValidationProvider 
        :name="field"
        :rules="rules"
        v-slot="{ errors }"
        slim
    >
        <v-text-field
            v-model="innerValue"
            :error-messages="errors"
            :label="label"
            :suffix="suffix"
            :disabled="false"
            :clearable="false"
            :readonly="true"
            class="ml-4 mr-4" 
            :alvqa="alvqa"
        >
            <template v-slot:append>
                <BaseTooltip v-if="iconTooltipText !== ''">
                    <template v-slot:content><v-icon small color="grey" :alvqa="alvqa +'-icon-info'">fa-info-circle</v-icon></template>
                    <template v-slot:text><span>{{ iconTooltipText }}</span></template>
                </BaseTooltip>
            </template>
        </v-text-field>
    </ValidationProvider>
</template>

<script>
import VTextField from 'vuetify/es5/components/VTextField'
import BaseTooltip from '@/components/_base/BaseTooltip'

export default {
    name: "BaseReadOnlyTextField",
    extends: VTextField,
    components: {
        BaseTooltip
    },
    props: {
        innerValue: String | Number,
        iconTooltipText: {
            type: String,
            default: ''
        },
        alvqa: {
            type: String,
            default: ''
        },
        // validation
        field: String,
        rules: {
            type: [Object, String],
            default: ""
        },
    },
}
</script>